import type { AnchorHTMLAttributes, MouseEvent } from "react";

interface AppLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
  onNavigate: (path: string) => void;
}

/**
 * A real <a href> that intercepts plain left-clicks for in-app navigation,
 * but leaves modified clicks (new tab, middle click, etc.) to the browser.
 * Used everywhere so links stay honest (right-click/open-in-tab still work)
 * even for routes the app doesn't render a full page for yet.
 */
export function AppLink({ href, onNavigate, onClick, children, ...rest }: AppLinkProps) {
  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    onClick?.(event);
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    onNavigate(href);
  }

  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
